module.exports = __webpack_public_path__ + "minigame-7d1e5b4967af13e2cfa90dc95dd835b1.svg";